import { render } from "./CheckPage.vue?vue&type=template&id=2fa3210b&scoped=true"
import script from "./CheckPage.vue?vue&type=script&lang=js"
export * from "./CheckPage.vue?vue&type=script&lang=js"

import "./CheckPage.vue?vue&type=style&index=0&id=2fa3210b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa3210b"]])

export default __exports__